import { OneTrustCookieGroup } from '~/assets/constants/cookie-consent';

// plugins/bazaarvoice.client.js
export default defineNuxtPlugin(() => {
  const env_config = useRuntimeConfig();
  const is_production = env_config.public.featureFlags.enableBVPixel;

  const rootStore = useRootStore();
  /**
   * @description verify cookie consent first before $BV pixel tracking
   */
  const checkAnalyticsConsent = rootStore.checkConsent(OneTrustCookieGroup.Analytical);

  const config = {
    clientName: 'toolstation-nl',
    siteId: 'main_site',
    environment: 'production',
    locale: 'nl_NL',
  };

  // Load BV script
  const loadBVScript = () => {
    const script = document.createElement('script');
    script.defer = true;
    script.src = `https://apps.bazaarvoice.com/deployments/${config.clientName}/${config.siteId}/${config.environment}/${config.locale}/bv.js`;
    document.head.appendChild(script);

    if (env_config.public.appDebug) {
      const debugStore = useDebugStore();
      debugStore.services.bazaarvoice.enabled = true;
      (debugStore.services.bazaarvoice.siteId as any) = config.siteId;
    }
  };

  // Initialize BV callback
  (window as any).bvCallback = function (BV: any) {
    (window as any).$BV = BV;
  };

  if (is_production) {
    loadBVScript();
  }

  // Provide tracking utilities
  const trackTransaction = (transactionData: any) => {
    if (!is_production || !checkAnalyticsConsent) return;

    if (
      !(window as any).$BV ||
      !(window as any).$BV?.pixel ||
      !(window as any).$BV?.pixel?.trackTransaction
    ) {
      console.warn('BV niet geïnitialiseerd');
      return;
    }

    (window as any).$BV?.pixel?.trackTransaction(transactionData);
  };

  // Track page view
  const trackPageView = () => {
    if (!is_production || !checkAnalyticsConsent) return;

    if (
      !(window as any).$BV ||
      !(window as any).$BV?.pixel ||
      !(window as any).$BV?.pixel?.trackPageView
    ) {
      console.warn('BV niet geïnitialiseerd');
      return;
    }

    (window as any).$BV?.pixel?.trackPageView();
  };

  // Track other events
  const trackEvent = (eventName: string, eventData: Record<string, any> = {}) => {
    if (!is_production || !checkAnalyticsConsent) return;

    if (
      !(window as any).$BV ||
      !(window as any).$BV?.pixel ||
      !(window as any).$BV?.pixel?.trackEvent
    ) {
      console.warn('BV niet geïnitialiseerd');
      return;
    }

    (window as any).$BV?.pixel?.trackEvent(eventName, eventData);
  };

  return {
    provide: {
      bv: {
        trackTransaction,
        trackPageView,
        trackEvent,
      },
    },
  };
});
